<template>
  <v-dialog :model-value="true" persistent>
    <v-card class="mx-auto" width="640">
      <template #title>
        {{ props.title }}
      </template>

      <template #text>
        <p class="body-1 text-pre-wrap">{{ props.message }}</p>
      </template>

      <v-card-actions class="justify-end">
        <div>
          <v-btn
            variant="outlined"
            color="neutral"
            :text="props.negativeButtonLabel ?? t('button.cancel')"
            @click="onClickNegativeButton"
          />

          <v-btn
            variant="flat"
            :color="props.positiveButtonColor"
            :text="props.positiveButtonLabel"
            @click="onClickPositiveButton"
          />
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';
import type { ConfirmDialogParam } from '@/types/models/common.d';

type Props = Omit<ConfirmDialogParam, 'onClose'>;

type Emits = {
  close: [isOk: boolean];
};

const props = withDefaults(defineProps<Props>(), {
  positiveButtonColor: 'primary',
  negativeButtonLabel: undefined,
});

const emits = defineEmits<Emits>();

const { t } = useI18n();

const onClickNegativeButton = (): void => {
  emits('close', false);
};

const onClickPositiveButton = (): void => {
  emits('close', true);
};
</script>

<style lang="scss" scoped></style>
